import { render, staticRenderFns } from "./ActionTile.vue?vue&type=template&id=74cfa545&scoped=true"
import script from "./ActionTile.vue?vue&type=script&lang=js"
export * from "./ActionTile.vue?vue&type=script&lang=js"
import style0 from "./ActionTile.vue?vue&type=style&index=0&id=74cfa545&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cfa545",
  null
  
)

export default component.exports